"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _customHistory = _interopRequireDefault(require("./customHistory"));

var isClient = typeof window !== "undefined";
/**
 * Navigates to a specified route.
 * @param {string} to A URL to navigate to.
 * @param {Object} state An optional object of state to pass to the next route.
 *
 * @example
 * router.navigate("/sign-in")
 * router.navigate("/sign-in", {redirectPath: "/previousRoute"})
 */

var navigate = function navigate(to, state) {
  _customHistory["default"].push(to, state);
};
/**
 * Redirects to a specified route.
 * @param {string} to A URL to redirect to.
 * @param {Object} state An optional object of state to pass to the next route.
 *
 * @example
 * router.redirect("/reset-password")
 * router.redirect("/reset-password", {token: "xxxxx"})
 */


var redirect = function redirect(to, state) {
  _customHistory["default"].replace(to, state);
};
/**
 * Checks if a specified path matches the current URL
 * the browser is on.
 *
 * This only checks for *inclusion* of the path under test.
 * If the path under test is contained anywhere within the
 * browser's current URL, this will return true.
 *
 * @param {string} pathToTest A path to test against.
 * @returns {bool} true if there is a match, false otherwise.
 *
 * @example
 * router.isMatch("sign-in")
 */


var isMatch = function isMatch(pathToTest) {
  var currentPath = _customHistory["default"].location.pathname;
  return currentPath.includes(pathToTest);
};
/**
 * Returns the current route.
 */


var current = function current() {
  return _customHistory["default"].location.pathname;
};
/**
 * A simple custom router. This can be used in client apps
 * through the `useRouter()` hook.
 */


var router = isClient ? {
  navigate: navigate,
  redirect: redirect,
  isMatch: isMatch,
  current: current
} : {
  // Stub the router when server-side rendering
  navigate: function navigate() {
    return null;
  },
  redirect: function redirect() {
    return null;
  },
  isMatch: function isMatch() {
    return null;
  },
  current: function current() {
    return null;
  }
};
var _default = router;
exports["default"] = _default;